import * as React from 'react';
import { ApplicationContext } from '../context/Contexts';
import { TranslateFn } from '../types/translator';

/** Bound `t(key, default)` translator read from the application context — no prop drilling. */
export const useTranslate = (): TranslateFn => {
  const { translatorService } = React.useContext(ApplicationContext);
  return React.useCallback(
    (key: string, def: string) => translatorService.Tranlate(key, def),
    [translatorService]
  );
};
